export enum TemplateTypeEnum {
  WORD = 'docx',
  EXCEL = 'xlsx',
}
